export default __webpack_public_path__ + "static/media/IconCheckCircle.ffaacffa.jpg";